import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AuthService from "../services/authService";

const defaultLoginState = {
  loginLoading: false,
  loginData: null,
  loginError: null,
};

const defaultForgotPasswordState = {
  forgotPasswordLoading: false,
  forgotPasswordLoginData: null,
  forgotPasswordLoginError: null,
};

const defaultResetPasswordState = {
  resetPasswordLoading: false,
  resetPasswordLoginData: null,
  resetPasswordLoginError: null,
};

const fetchLoginData = createAsyncThunk("auth/login", async (loginReq) => {
  return await AuthService.callLogInApi(loginReq);
});

const fetchForgotPasswordData = createAsyncThunk("auth/forgotPassword", async (loginReq) => {
  return await AuthService.callForgotPasswordApi(loginReq);
});

const fetchResetPasswordData = createAsyncThunk("auth/resetPassword", async (loginReq) => {
  return await AuthService.callResetPasswordApi(loginReq);
});

const loginReducer = createSlice({
  name: "login",
  initialState: defaultLoginState,
  extraReducers: (builder) => {
    builder.addCase(fetchLoginData.pending, (state) => {
      state.loginLoading = true;
    });
    builder.addCase(fetchLoginData.fulfilled, (state, action) => {
      state.loginLoading = false;
      state.loginData = action.payload;
      state.loginError = "";
    });
    builder.addCase(fetchLoginData.rejected, (state, action) => {
      state.loginLoading = false;
      state.loginData = null;
      state.loginError = action.error.message;
    });
  },
});

const fetchForgotPasswordReducer = createSlice({
  name: "forgotPassword",
  initialState: defaultForgotPasswordState,
  extraReducers: (builder) => {
    builder.addCase(fetchForgotPasswordData.pending, (state) => {
      state.forgotPasswordLoading = true;
    });
    builder.addCase(fetchForgotPasswordData.fulfilled, (state, action) => {
      state.forgotPasswordLoading = false;
      state.forgotPasswordLoginData = action.payload;
      state.forgotPasswordLoginError = "";
    });
    builder.addCase(fetchForgotPasswordData.rejected, (state, action) => {
      state.forgotPasswordLoading = false;
      state.forgotPasswordLoginData = null;
      state.forgotPasswordLoginError = action.error.message;
    });
  },
});

const fetchResetPasswordReducer = createSlice({
  name: "resetPassword",
  initialState: defaultResetPasswordState,
  extraReducers: (builder) => {
    builder.addCase(fetchResetPasswordData.pending, (state) => {
      state.resetPasswordLoading = true;
    });
    builder.addCase(fetchResetPasswordData.fulfilled, (state, action) => {
      state.resetPasswordLoading = false;
      state.resetPasswordLoginData = action.payload;
      state.resetPasswordLoginError = "";
    });
    builder.addCase(fetchResetPasswordData.rejected, (state, action) => {
      state.resetPasswordLoading = false;
      state.resetPasswordLoginData = null;
      state.resetPasswordLoginError = action.error.message;
    });
  },
});


export const LoginReducer = loginReducer.reducer;
export const FetchForgotPasswordReducer = fetchForgotPasswordReducer.reducer;
export const FetchResetPasswordReducer = fetchResetPasswordReducer.reducer;


export const FetchLoginData = fetchLoginData;
export const FetchForgotPasswordData = fetchForgotPasswordData;
export const FetchResetPasswordData = fetchResetPasswordData;
